import { IUserSummary } from '../../types/global/helper';

export const types = {
    GET_MY_REQUESTS: 'GET_MY_REQUESTS',
    GET_MY_REQUESTS_SUCCESS: 'GET_MY_REQUESTS_SUCCESS',
    GET_MY_REQUESTS_FAIL: 'GET_MY_REQUESTS_FAIL',

    CREATE_REQUEST: 'CREATE_REQUEST',
    CREATE_REQUEST_SUCCESS: 'CREATE_REQUEST_SUCCESS',
    CREATE_REQUEST_FAIL: 'CREATE_REQUEST_FAIL',

    RESOLVE_REQUEST: 'RESOLVE_REQUEST',
    RESOLVE_REQUEST_SUCCESS: 'RESOLVE_REQUEST_SUCCESS',
    RESOLVE_REQUEST_FAIL: 'RESOLVE_REQUEST_FAIL',

    GET_REQUESTS: 'GET_REQUESTS',
    GET_REQUESTS_SUCCESS: 'GET_REQUESTS_SUCCESS',
    GET_REQUESTS_FAIL: 'GET_REQUESTS_FAIL',

    UPDATE_REQUEST: 'UPDATE_REQUEST',
    UPDATE_REQUEST_SUCCESS: 'UPDATE_REQUEST_SUCCESS',
    UPDATE_REQUEST_FAIL: 'UPDATE_REQUEST_FAIL',

    REQUEST_PAYOUT: 'REQUEST_PAYOUT',
    REQUEST_PAYOUT_SUCCESS: 'REQUEST_PAYOUT_SUCCESS',
    REQUEST_PAYOUT_FAIL: 'REQUEST_PAYOUT_FAIL',
};

export interface IMainRequestBody {
    request_type?: TRequestType;
    request_status?: TRequestStatus;
    metadata?: TRequestMetadata;
}

export interface IRequestPayout extends IMainRequestBody {
    payout_amount: number;
    payout_external_account: string;
}

export type TRequestType =
    | 'account_verification'
    | 'contest_code'
    | 'account_deletion'
    | 'campaign_request'
    | 'others'
    | 'initiate_campaign'
    | 'payout';
export type TRequestStatus = 'pending' | 'approved' | 'denied' | 'action requested';

export type TRequestMetadata = {
    contestId?: string;
    [key: string]: any;
};

export interface ICreateContestRequest {
    request_type: TRequestType;
    metadata: TRequestMetadata;
}

export interface IResolveRequests {
    request_status: TRequestStatus;
    reason: string;
    requestId: string;
    resolution_message?: string;
    resubmit?: boolean;
}

export interface IUpdateRequests {
    requestId: string;
    resubmit?: boolean;
    withdraw?: boolean;
}

export interface IRequestResponse extends IMainRequestBody {
    payout_amount?: number;
    payout_external_account?: string;
}

export interface IContestRequest extends IMainRequestBody {
    resolved: boolean;
    _id: string;
    created_by: string;
    user: IUserSummary;
    createdAt: string;
    updatedAt: string;
    reason: string;
    resolved_by: string;
    resolution_message?: string;
    id: string;
}

export interface IInitialRequestState {
    requests: IContestRequest[];
    gettingRequests?: boolean;
    resolvingRequests?: boolean;
    userRequests: IContestRequest[];
    creatingRequest?: boolean;
    requestErrMsg?: any;
}

export interface IGetRequests {
    contestId?: string;
    page?: number;
    limit?: number;
}
